<template>
  <div class="row">
    <h2 class="col-12 mb-4">{{ $t('autocaller_v2.monitoring.campaign.topic') }}</h2>
    <div class="col-6">
      <p>
        {{ $t('autocaller_v2.monitoring.campaign.type') }}:
        {{ $t(`autocaller_v2.monitoring.type.${campaign.type}`) }}
      </p>
      <p v-if="tasks.calculated_asr == null" class="text-muted">
        {{ $t('autocaller_v2.monitoring.field.calc') }}: {{ campaign.asr || campaign.default_asr }}%
        <icon type="ios-loading" class="loading" />
      </p>
      <p v-else>ASR: {{ asks.calculated_asr }}</p>
      <p v-if="campaign.asr == 0">
        <a href="#" class="text-decoration-underline" @click.prevent="dropAsr">
          {{ $t('autocaller_v2.monitoring.field.drop') }}
        </a>
      </p>
      <p>
        <router-link
          tag="a"
          class="dropdown-item-icon dropdown-item-icon--edit text-decoration-underline"
          :to="{ name: 'autocaller_v2.campaign.edit', params: { id: campaign_id } }"
        >
          {{ $t('shared.component.table.action.edit') }}
          {{ $t('autocaller_v2.monitoring.field.campaign') }}
        </router-link>
      </p>
    </div>
    <div class="col-6">
      <p>{{ instance }}</p>
      <p>
        {{ $t('autocaller_v2.campaign.field.percent_lost_calls') }}:
        {{ campaign.bounce_drop_threshold ? campaign.bounce_drop_threshold : 0 }} %
      </p>
      <p>
        {{ $t('autocaller_v2.monitoring.field.avg_time') }}: {{ average_dial_time }}
        {{ $t('autocaller_v2.monitoring.field.sec') }}
      </p>
      <p v-if="campaign.type != 'progressive'">
        {{ $t('autocaller_v2.monitoring.campaign.avg_task') }}:
        {{ campaign.average_task_duration }} {{ $t('autocaller_v2.monitoring.field.sec') }}
      </p>
    </div>
  </div>
</template>

<script>
  import { CampaignsService } from '@autocaller_v2/services/CampaignsService';
  import { InstanceService } from '@autocaller_v2/services/InstanceService';
  export default {
    props: {
      campaign: {
        type: [Object, Array],
        default: () => {}
      },
      campaign_id: {
        type: [String, Number],
        default: ''
      },
      tasks: {
        type: [Object, Array],
        default: () => {}
      }
    },
    data() {
      return {
        region: []
      };
    },
    computed: {
      average_dial_time() {
        return this.campaign.average_task_duration - this.tasks.threshold;
      },
      connected() {
        return this.operators.filter(function (value) {
          return value.state === 'connected';
        }).length;
      },
      instance() {
        let res = [];
        let id = this.campaign.instance_id;
        this.region.forEach((item) => res.push(item.instances));
        res.filter(function (obj) {
          obj.filter(function (d) {
            if (d.id == id) {
              res = d;
            }
          });
        });
        return res.caption;
      }
    },
    created() {
      InstanceService.getList().then((data) => {
        this.region = data || [];
      });
    },
    methods: {
      dropAsr() {
        CampaignsService.dropAsr(this.campaign_id);
      }
    }
  };
</script>
<style lang="scss" scoped>
  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }
  .loading {
    animation: spinner 2s linear infinite;
  }
</style>
